import { render } from "./newyear.vue?vue&type=template&id=a7d2ae4c"
import script from "./newyear.vue?vue&type=script&lang=js"
export * from "./newyear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__